import { Permissions } from '@prodcard/core'
import { NavigationItem } from '../components'

export function createBaseLinks(): NavigationItem[] {
  return [
    {
      order: 1,
      title: 'Пользователи',
      url: '/users',
      icon: 'mdi-account-tie',
      permissions: [Permissions.USERS_VIEW, Permissions.ME_USERS_VIEW],
    },
    {
      order: 2,
      title: 'Граждане',
      url: '/citizens',
      icon: 'mdi-account',
      permissions: [Permissions.CITIZENS_VIEW, Permissions.ME_CITIZENS_VIEW],
    },
    {
      order: 3,
      title: 'Пункты выдачи карт',
      icon: 'mdi-card-plus-outline',
      url: '/card-issue-points',
      permissions: [Permissions.CARD_ISSUE_POINTS_VIEW, Permissions.ME_CARD_ISSUE_POINTS_VIEW],
    },
    {
      order: 4,
      title: 'Торговые объекты',
      url: '/sales-points',
      icon: 'mdi-store-outline',
      permissions: [Permissions.SALES_POINTS_VIEW, Permissions.ME_SALES_POINTS_VIEW],
    },
    {
      order: 6,
      title: 'Отчеты',
      icon: 'mdi-file-document-edit-outline',
      children: [
        {
          order: 1,
          title: 'Учет выдачи карт',
          url: '/issuance-card-stats',
          permissions: [Permissions.ISSUANCE_CARDS_STATS_VIEW, Permissions.ME_ISSUANCE_CARDS_STATS_VIEW],
        },
        {
          order: 2,
          title: 'Учет использованных карт',
          url: '/used-cards-stats',
          permissions: [Permissions.USED_CARDS_STATS_VIEW, Permissions.ME_USED_CARDS_STATS_VIEW],
        },

        {
          order: 3,
          title: 'Учет выдачи продовольствия',
          url: '/actual-issue-products',
          permissions: [Permissions.ACTUAL_ISSUE_PRODUCTS_VIEW, Permissions.ME_ACTUAL_ISSUE_PRODUCTS_VIEW],
        },
        {
          order: 4,
          title: 'Продовольственный план',
          url: '/product-plan',
          permissions: [Permissions.PRODUCT_SUPPLIES_VIEW],
        },
      ],
    },
    {
      order: 6,
      title: 'Справочники',
      icon: 'mdi-list-box-outline',
      children: [
        {
          order: 1,
          title: 'Нормы потребления',
          url: '/consumption-rates',
          permissions: [Permissions.CONSUMPTION_RATES_VIEW_STATS],
        },
        {
          order: 2,
          title: 'Категории граждан',
          url: '/citizen-categories-coefficients',
          permissions: [Permissions.CITIZEN_CATEGORIES_COEFFICIENTS_VIEW],
        },
        {
          order: 3,
          title: 'Норматив на талон',
          url: '/consumption-standards',
          permissions: [Permissions.CONSUMPTION_STANDARDS_VIEW_STATS],
        },
      ],
    },
    { order: 7, title: 'Инструменты', url: '/tools', icon: 'mdi-tools', permissions: [Permissions.TOOLS_VIEW] },
  ]
}
